import { $axios } from '~/utils/api'
const EMBED_BASE_URL = 'https://maps.google.com/maps/embed/v1/'
const BASE_URL = 'https://maps.googleapis.com/maps/api/'
const STREET_VIEW = 'streetview/'
const METADATA = 'metadata'

const streetViewMetadata = (
  latitude: number,
  longitude: number,
  apiKey: string
): Promise<any> =>
  $axios.$get(
    `${BASE_URL}${STREET_VIEW}${METADATA}?location=${latitude},${longitude}&key=${apiKey}`
  )

export { streetViewMetadata, EMBED_BASE_URL, STREET_VIEW }
